import React, { useState } from "react";
import { Card, CardBody, Col, Collapse } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { ButtonWithDataBsTarget, CollapseAccordions, LinkwithHref } from "../../../../Constant";
import { ACCORDION_COLLAPSE } from "../../../../Data/UiKit/Accordion";
import { Btn, P } from "../../../../AbstractElements";

const CollapseAccordion = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  return (
    <Col md="6" sm="12">
      <Card>
        <CommonCardHeader title={CollapseAccordions} span={ACCORDION_COLLAPSE} />
        <CardBody>
          <P className="common-flex">
            <Btn color="dark" onClick={toggle}>{LinkwithHref}</Btn>
            <Btn color="dark" onClick={toggle}>{ButtonWithDataBsTarget}</Btn>
          </P>
          <Collapse isOpen={isOpen}>
            <Card color="dark" className="mb-0 dark-accordion">
              <CardBody>Some placeholder content for the collapse component. This panel is hidden by default but revealed when the user activates the relevant trigger.</CardBody>
            </Card>
          </Collapse>
        </CardBody>
      </Card>
    </Col>
  );
};

export default CollapseAccordion;
